module.exports = __webpack_public_path__ + "img/image16.2d86588e.png";